import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Select from 'react-select';
import uuidv4 from 'uuid/v4';
import { Modal, FormItem, DataTable } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { getDmService, getByDmService } from '../../../services/Api';
import CardAgency from './card-agency';
import ConsultantsVersosStatus from './consultants-versos-status';
import CardChartAgency from './card-chart-agency';
import { DatePicker, Breadcrumb, Card } from '../../../components';
import ModalDm from '../../../components/Modal/ModalDm';
import ListCardItens from './ListCardItens';
import { forceDownloadAsync } from '../../../lib/validations';

const { TableContainer, Table, TableHead, TableRow, TableBody, TableHeader, TableCell } = DataTable;

// const { IMAGE_PATH } = appConfig;

class Dashboard extends React.PureComponent {
  state = {
    avaliacoes: {},
    avaliacoesCriacao: {},
    avaliacoesMaterial: {},
    avaliacoesAtendimento: {},
    trimestres: [],
    totais: {
      total: 0,
      triagem: 0,
      devolvidos: 0,
      aprovacaoComercial: 0,
      criacao: 0,
      revisaoInterna: 0,
      aguardandoAprovacao: 0,
      fechamentoArquivo: 0,
      aguardandoProducao: 0,
      fornecedor: 0,
      disponivelRetirada: 0,
      emTransporte: 0,
      cancelados: 0,
      reprovados: 0,
      atrasados: 0,
      finalizados: 0,
    },
    criacaoDesigners: {
      totalPedidos: 0,
      prioridadeAlta: 0,
      reprovados: 0,
      aguardandoAprovacao: 0,
      fechamentoArquivo: 0
    },
    fornecedores: {
      totalPedidos: 0,
      producao: 0,
      disponivelRetirada: 0,
      emTransporte: 0
    },
    designers: [],
    reposicao: [],
    implantacao: [],
    fornecedoresList: [],
    avaliacoesTrimestreList: [],
    mediasTrimestreList: [],
    fornecedoresPendentes: [],
    // mediasTrimestre: [],
    avaliacoesTrimestre: [],
    currentDatesCreate: {
      dateInit: moment(new Date()).format("DD/MM/YY"),
      dateFinish: moment(new Date()).format("DD/MM/YY")
    },
    currentDatesProviders: {
      dateInit: moment(new Date()).format("DD/MM/YY"),
      dateFinish: moment(new Date()).format("DD/MM/YY")
    },
    openMdFiltro: false,
    openProviders2: false,
    showDate: false,
    openDesigners: false,
    openProviders: false,
    listDesigners: [],
    listProviders: [],
    fornecedoresSelecionados: [],
    openExportUnificado: false,
    openExport: false,
    openExportAgencia: false,
    lastFilter: 15,
    fornecedorSelecionado: null,
    rowsData: [],
    headersData: [],
    width: 0,
    trimestre: null,
    avaliacoesService: null,
    mediaTrimestre: 0,
    mediasTrimestreCriacao: 0,
    mediasTrimestreMaterial: 0,
    mediasTrimestreAtendimento: 0,
    qtdAvaliadosTrimestre: 0,
  };

  componentDidMount = async () => {
    await this.setFilter(15);
    this.applicationValue(true);
    try {
      const totais = await getDmService('/Dashboard/Agencia');
      await this.setState({ totais });
      const { dateInit, dateFinish } = this.state;
      await this.relatorioCriacaoAgencia(dateInit, dateFinish);
      await this.relatorioFornecedoresAgencia(dateInit, dateFinish);
      const trimestre = moment().format('Y-Q');

      const { avaliacoes } = totais || {};
      const trimestres = avaliacoes.map(p => p.trimestre)

      this.setState({ avaliacoesService: avaliacoes, trimestres, trimestre }, () => {
        this.loadAvaliacoes();
      });

    } catch (error) {
      console.log("error", error);
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  loadAvaliacoes = () => {
    const { avaliacoesService: avaliacoes, trimestre } = this.state;
    const trimestreSelecionado = avaliacoes.find(p => p.trimestre === trimestre)
    const anoSelecionado = avaliacoes.filter(p => p.trimestre.startsWith(trimestre.split('-')[0]));
    // console.log("anoSelecionado", anoSelecionado, trimestreSelecionado, avaliacoes, trimestre)
    const mediasTrimestreCriacao = trimestreSelecionado ? trimestreSelecionado.meses.map(p => p.mediaCriacao.toFixed(2)) : [];
    const mediasTrimestreMaterial = trimestreSelecionado ? trimestreSelecionado.meses.map(p => p.mediaMaterial.toFixed(2)) : [];
    const mediasTrimestreAtendimento = trimestreSelecionado ? trimestreSelecionado.meses.map(p => p.mediaAtendimento.toFixed(2)) : [];
    const mediasTrimestreList = trimestreSelecionado ? trimestreSelecionado.meses.map(p => p.mes) : [];
    const avaliacoesTrimestre = trimestreSelecionado ? trimestreSelecionado.meses.map(p => p.pedidosAvaliados) : [];
    const qtdAvaliadosTrimestre = trimestreSelecionado ? trimestreSelecionado.meses.map(p => p.pedidosAvaliados).reduce((a, b) => a + b) : 0;
    const mediaTrimestre = qtdAvaliadosTrimestre === 0 ? 0 : trimestreSelecionado ? (trimestreSelecionado.meses.map(p => p.notas).reduce((a, b) => a + b) / qtdAvaliadosTrimestre) : 0;
    const avaliacoesDataCriacao = {
      finalizados: (trimestreSelecionado || { pedidos: '--' }).pedidos,
      finalizadosAvaliados: (trimestreSelecionado || { pedidosAvaliados: '--' }).pedidosAvaliados,
      trimeste1: (anoSelecionado.find(p => p.trimestre.endsWith('-1')) || { mediaCriacao: '--' }).mediaCriacao,
      trimeste2: (anoSelecionado.find(p => p.trimestre.endsWith('-2')) || { mediaCriacao: '--' }).mediaCriacao,
      trimeste3: (anoSelecionado.find(p => p.trimestre.endsWith('-3')) || { mediaCriacao: '--' }).mediaCriacao,
      trimeste4: (anoSelecionado.find(p => p.trimestre.endsWith('-4')) || { mediaCriacao: '--' }).mediaCriacao,
    }
    const avaliacoesDataMaterial = {
      finalizados: (trimestreSelecionado || { pedidos: '--' }).pedidos,
      finalizadosAvaliados: (trimestreSelecionado || { pedidosAvaliados: '--' }).pedidosAvaliados,
      trimeste1: (anoSelecionado.find(p => p.trimestre.endsWith('-1')) || { mediaMaterial: '--' }).mediaMaterial,
      trimeste2: (anoSelecionado.find(p => p.trimestre.endsWith('-2')) || { mediaMaterial: '--' }).mediaMaterial,
      trimeste3: (anoSelecionado.find(p => p.trimestre.endsWith('-3')) || { mediaMaterial: '--' }).mediaMaterial,
      trimeste4: (anoSelecionado.find(p => p.trimestre.endsWith('-4')) || { mediaMaterial: '--' }).mediaMaterial,
    }
    const avaliacoesDataAtendimento = {
      finalizados: (trimestreSelecionado || { pedidos: '--' }).pedidos,
      finalizadosAvaliados: (trimestreSelecionado || { pedidosAvaliados: '--' }).pedidosAvaliados,
      trimeste1: (anoSelecionado.find(p => p.trimestre.endsWith('-1')) || { mediaAtendimento: '--' }).mediaAtendimento,
      trimeste2: (anoSelecionado.find(p => p.trimestre.endsWith('-2')) || { mediaAtendimento: '--' }).mediaAtendimento,
      trimeste3: (anoSelecionado.find(p => p.trimestre.endsWith('-3')) || { mediaAtendimento: '--' }).mediaAtendimento,
      trimeste4: (anoSelecionado.find(p => p.trimestre.endsWith('-4')) || { mediaAtendimento: '--' }).mediaAtendimento,
    }

    this.setState({
      avaliacoesCriacao: avaliacoesDataCriacao,
      avaliacoesMaterial: avaliacoesDataMaterial,
      avaliacoesAtendimento: avaliacoesDataAtendimento,
      mediasTrimestreCriacao,
      mediasTrimestreMaterial,
      mediasTrimestreAtendimento,
      avaliacoesTrimestre,
      avaliacoesTrimestreList: mediasTrimestreList,
      mediasTrimestreList, mediaTrimestre,
      qtdAvaliadosTrimestre
    });

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  relatorioCriacaoAgencia = async (dateInit, dateFinish) => {
    const { selectedOption } = this.state;
    try {
      const data = await getDmService(`/Dashboard/RelatorioCriacaoAgencia?DataInicial=${moment(dateInit).format("MM-DD-YYYY")}&DataFinal=${moment(dateFinish).format("MM-DD-YYYY")}&selectedOption=${selectedOption}`);
      const designers = await data.designers.map(item => item.nome);
      const reposicao = await data.designers.map(item => item.reposicao);
      const implantacao = await data.designers.map(item => item.implantacao);
      let listDesigners = [];

      listDesigners = await data.designers.map(item => ({
        nome: item.nome,
        id: item.id,
        list: [
          { id: item.id, label: "Total de Pedidos em criação", total: item.totalPedidos, url: `/admin/agencia/pedidos/criacao?designer=${item.id}&${this.getDateFilter()}` },
          { id: item.id, label: "Total de Itens em criação", total: item.totalItens, url: `/admin/agencia/pedidos/criacao?designer=${item.id}&${this.getDateFilter()}` },
          { id: item.id, label: "Itens de Prioridade Alta em criação", total: item.prioridadeAlta, url: `/admin/agencia/pedidos/criacao?prioridade=1&designer=${item.id}&${this.getDateFilter()}` },
          { id: item.id, label: "Itens de Prioridade Media em criação", total: item.prioridadeMedia, url: `/admin/agencia/pedidos/criacao?prioridade=3&designer=${item.id}&${this.getDateFilter()}` },
          { id: item.id, label: "Itens de Prioridade Baixa em criação", total: item.prioridadeBaixa, url: `/admin/agencia/pedidos/criacao?prioridade=2&designer=${item.id}&${this.getDateFilter()}` },
          { id: item.id, label: "Itens Reprovados", total: item.reprovados, url: `/admin/agencia/pedidos/criacao?designer=${item.id}&filtrarpor=reprovados&${this.getDateFilter()}` },
          { id: item.id, label: "Itens Atrasados", total: item.atrasados, url: `/admin/agencia/pedidos/criacao?designer=${item.id}&filtrarpor=atrasados&${this.getDateFilter()}` },
          { label: "Itens Aguardando Aprovação", total: item.aguardandoAprovacao, url: `/admin/agencia/pedidos/aprovacaoDeArte?designer=${item.id}&${this.getDateFilter()}` },
          { id: item.id, label: "Itens em Fechamento de Arquivo", total: item.fechamentoArquivo, url: `/admin/agencia/pedidos/fechamentoDeArquivo?designer=${item.id}&${this.getDateFilter()}` }
        ]
      }));

      await this.setState({
        designers,
        reposicao,
        implantacao,
        criacaoDesigners: {
          totalPedidos: data.totalPedidos,
          totalItens: data.totalItens,
          prioridadeAlta: data.prioridadeAlta,
          reprovados: data.reprovados,
          aguardandoAprovacao: data.aguardandoAprovacao,
          fechamentoArquivo: data.fechamentoArquivo
        },
        listDesigners
      })

    } catch (error) {
      console.log("error", error)
    }
  }

  relatorioFornecedoresAgencia = async (dateInit, dateFinish) => {
    const { selectedOption } = this.state;
    try {
      const data = await getDmService(`/Dashboard/RelatorioFornecedoresAgencia?DataInicial=${dateInit ? moment(dateInit).format("MM-DD-YYYY") : ""}&DataFinal=${dateFinish ? moment(dateFinish).format("MM-DD-YYYY") : ""}&selectedOption=${selectedOption}`);
      const fornecedoresList = await data.fornecedores.map(item => item.nome);
      const fornecedoresSelecionados = await data.fornecedores.sort((a, b) => a.nome > b.nome ? 1 : -1);
      // console.log(data)
      const fornecedoresPendentes = await data.fornecedores.map(item => item.pendente);
      let listProviders = [];

      listProviders = await data.fornecedores.map(item => ({
        nome: item.nome,
        list: [
          { label: "Total de Pedidos", total: item.totalPedidos },
          { label: "Produção", total: item.producao },
          { label: "Disponível para Retirada", total: item.disponivelParaRetirada },
          { label: "Em Transporte", total: item.emTransporte }
        ]
      }));

      await this.setState({
        fornecedoresSelecionados,
        fornecedoresList,
        fornecedoresPendentes,
        fornecedores: {
          totalPedidos: data.totalPedidos,
          producao: data.producao,
          disponivelRetirada: data.disponivelParaRetirada,
          emTransporte: data.emTransporte
        },
        listProviders
      })

    } catch (error) {
      console.log("error", error)
    }
  }

  openFiltro = (tipo) => {
    this.setState(prevState => ({
      openMdFiltro: !prevState.openMdFiltro,
      filterOpen: tipo,
      dateInit: null,
      dateFinish: null
    }));
  }

  loadPedidosFornecedor = async (id) => {
    const { dateInit, dateFinish, selectedOption } = this.state;

    const dados = await getDmService(`/Dashboard/RelatorioFornecedoresAgenciaDetalhe?DataInicial=${moment(dateInit).format("MM-DD-YYYY")}&DataFinal=${moment(dateFinish).format("MM-DD-YYYY")}&selectedOption=${selectedOption}&fornecedor=${id}`);
    const rowsData = dados ? dados.resultado.map(item => ({ id: uuidv4(), ...item })) : [];
    const headersData = dados ? dados.header : [];
    this.setState({ rowsData, headersData })
  }

  onChangeFornecedor = event => {
    if (event) {
      this.setState({
        fornecedorSelecionado: event,
      }, () => {
        this.loadPedidosFornecedor(event.id)
      })
    }
  }

  openMDListDesigners = () => {
    this.setState(prevState => ({
      openDesigners: !prevState.openDesigners,
    }));
  }

  openExcelUnificadoModal = () => {
    this.setState(prevState => ({
      openExportUnificado: !prevState.openExportUnificado,
    }));
  }

  openExelModal = () => {
    this.setState(prevState => ({
      openExport: !prevState.openExport,
    }));
  }

  openExelAgenciaModal = () => {
    this.setState(prevState => ({
      openExportAgencia: !prevState.openExportAgencia,
    }));
  }

  openMDListProviders = () => {
    this.setState(prevState => ({
      openProviders: !prevState.openProviders,
    }));
  }

  openMDListProviders2 = () => {
    this.setState(prevState => ({
      openProviders2: !prevState.openProviders2,
    }));
  }

  onChangeFilter = event => {
    const lastFilter = parseInt(event.target.value, 10)
    this.setState({ lastFilter, showDate: lastFilter === 3, selectedOption: lastFilter })
  }

  onChangeTrimestre = event => {
    const trimestre = event.target.value
    this.setState({ trimestre }, () => {
      this.loadAvaliacoes();
    })
  }

  setFilter = async (selected, filterOpen) => {
    let dateInit = null;
    let dateFinish = null;
    if (selected === 1) {
      dateInit = moment();
      dateFinish = moment();
    } else if (selected === 7) {
      dateInit = moment() // moment().startOf('week');
      dateFinish = moment().endOf('week');

    } else if (selected === 15) {
      dateInit = moment().add(-2, 'week');
      dateFinish = moment();
    } else if (selected === 2) {
      dateInit = moment() // moment().startOf('month');
      dateFinish = moment().endOf('month');
    }

    if (selected === 3) {
      await this.setState({
        showDate: true,
        selectedOption: selected
      })
    } else {
      const dates = {
        dateInit: dateInit.format("DD/MM/YYYY"),
        dateFinish: dateFinish.format("DD/MM/YYYY"),
      }
      const updateDates = {}

      if (filterOpen !== "fornecedores")
        updateDates.currentDatesCreate = dates;

      if (filterOpen !== "criacao")
        updateDates.currentDatesProviders = dates;

      await this.setState({
        dateInit,
        dateFinish,
        ...updateDates,
        selectedOption: selected,
        showDate: false
      })
    }
  }

  applicationValue = async (skipModal) => {
    const { lastFilter, filterOpen } = this.state;
    if (!skipModal)
      await this.setFilter(lastFilter, filterOpen)

    const {
      dateInit,
      dateFinish
    } = this.state;

    if (filterOpen === "criacao") {
      this.setState({
        currentDatesCreate: {
          dateInit: moment(dateInit).format("DD/MM/YY"),
          dateFinish: moment(dateFinish).format("DD/MM/YY")
        },
      }, () => {
        this.relatorioCriacaoAgencia(dateInit, dateFinish);
      })
      if (!skipModal)
        this.openFiltro()

    } else {
      this.setState({
        currentDatesProviders: {
          dateInit: moment(dateInit).format("DD/MM/YY"),
          dateFinish: moment(dateFinish).format("DD/MM/YY")
        },
      }, () => {
        this.relatorioFornecedoresAgencia(dateInit, dateFinish);
      })

      if (!skipModal)
        this.openFiltro()
    }
  }

  exportExcel = async () => {
    const { DataInicial, DataFinal } = this.state;
    try {
      const data = await getByDmService('/Dashboard/ExportarAgencia', `?DataInicial=${DataInicial ? moment(DataInicial).format("YYYY/MM/DD") : ""}&DataFinal=${DataFinal ? DataFinal.format("YYYY/MM/DD") : ""}`);

      const url = data;
      forceDownloadAsync(url);
    } catch (error) {
      toast.error('Ocorreu uma falha ao gerar o arquivo');
    }
  }

  exportExcelStatus = async () => {
    const { DataInicial, DataFinal } = this.state;
    try {
      const data = await getByDmService('/Dashboard/ExportarAgenciaStatus', `?DataInicial=${DataInicial ? moment(DataInicial).format("YYYY/MM/DD") : ""}&DataFinal=${DataFinal ? DataFinal.format("YYYY/MM/DD") : ""}`);

      const url = data;
      forceDownloadAsync(url);
    } catch (error) {
      console.error("erro exportExcel", error);
      toast.error('Ocorreu uma falha ao gerar o arquivo');
    }
  }

  exportExcelUnificado = async () => {
    const { DataInicial, DataFinal } = this.state;
    try {
      const data = await getByDmService('/Dashboard/ExportarAgenciaUnificado', `?DataInicial=${DataInicial ? moment(DataInicial).format("YYYY/MM/DD") : ""}&DataFinal=${DataFinal ? DataFinal.format("YYYY/MM/DD") : ""}`);

      const url = data;
      forceDownloadAsync(url);
    } catch (error) {
      console.error("erro exportExcel", error);
      toast.error('Ocorreu uma falha ao gerar o arquivo');
    }
  }

  onDateChangeInit = date => {
    this.setState({ dateInit: date });
  };

  onDateChangeFinish = date => {
    this.setState({ dateFinish: date });
  };

  onDateChange = (date, name) => {
    const data = date == null ? "" : moment(date)
    this.setState({ [name]: data });
  };

  handleDetail = (rowsData, row) => {
    const { history } = this.props;
    console.log("rowsData, row", rowsData, row)
    return history.push(`/admin/agencia/pedido/${row.id}`);
  }

  getDateFilter = () => {
    const { dateFinish } = this.state;
    // ${moment(dateInit).format('YYYY-MM-DD')}
    return `dtIniDesigner=&dtFimDesigner=${moment(dateFinish).format('YYYY-MM-DD')}`;
  }

  render() {
    const {
      totais,
      criacaoDesigners,
      fornecedores,
      fornecedoresList,
      fornecedoresPendentes,
      currentDatesCreate,
      currentDatesProviders,
      designers,
      reposicao,
      implantacao,
      openMdFiltro,
      dateInit,
      dateFinish,
      showDate,
      selectedOption,
      filtroOpen,
      openDesigners,
      openProviders,
      listDesigners,
      listProviders,
      openExportUnificado,
      openExport,
      openExportAgencia,
      DataInicial,
      DataFinal,
      openProviders2,
      fornecedoresSelecionados,
      fornecedorSelecionado,
      rowsData,
      headersData,
      width,
      trimestre,
      trimestres,
      mediasTrimestreCriacao,
      mediasTrimestreMaterial,
      mediasTrimestreAtendimento,
      avaliacoesTrimestre,
      avaliacoesTrimestreList,
      mediasTrimestreList,
      avaliacoes,
      avaliacoesCriacao,
      avaliacoesMaterial,
      avaliacoesAtendimento,
      filterOpen,
      mediaTrimestre,
      qtdAvaliadosTrimestre
    } = this.state;

    const newDate = new Date();
    const currentDate = moment(newDate).format("DD/MM/YY");
    const chartCriacao = {
      labels: designers,
      datasets: [
        {
          label: "Reposição",
          backgroundColor: "#202ad0",
          data: reposicao,
          stack: 'stack1'
        }, {
          label: "Implantação",
          backgroundColor: "#ff5871",
          data: implantacao,
          stack: 'stack1'
        }
      ]
    }

    const chartFornecedores = {
      labels: fornecedoresList,
      datasets: [
        {
          label: "Itens pendentes",
          backgroundColor: "#48d4bb",
          data: fornecedoresPendentes
        }
      ]
    }

    const chartAvaliacoesCriacao = {
      labels: mediasTrimestreList,
      datasets: [
        {
          label: "Notas para Criação",
          backgroundColor: "#ffc000",
          data: mediasTrimestreCriacao
        }
      ]
    }

    const chartAvaliacoesMaterial = {
      labels: mediasTrimestreList,
      datasets: [
        {
          label: "Notas para Materiais",
          backgroundColor: "#ffc000",
          data: mediasTrimestreMaterial
        }
      ]
    }

    const chartAvaliacoesAtendimento = {
      labels: mediasTrimestreList,
      datasets: [
        {
          label: "Notas para o Atendimento",
          backgroundColor: "#ffc000",
          data: mediasTrimestreAtendimento
        }
      ]
    }

    const chartAvaliacoesRealizadas = {
      labels: avaliacoesTrimestreList,
      datasets: [
        {
          label: "Qtd pedidos avaliados no período",
          backgroundColor: "#CCC",
          data: avaliacoesTrimestre
        }
      ]
    }

    return (
      <div>
        <Breadcrumb
          title="Dashboard Agência"
          description=""
          renderRight={(
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openExcelUnificadoModal()}
              >
                Exportar Excel Unificado
              </button>
              {/* <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openExelModal()}
              >
                Exportar Excel
              </button>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openExelAgenciaModal()}
              >
                Exportar por Status
              </button> */}
            </div>
          )}
        />
        <section id="content">
          <div className="bx--grid">
            <div className="bx--row dashborad-agency">
              <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6">
                <h2>
                  Hoje
                  <br />
                  <span className="current-date">
                    {currentDate}
                  </span>
                </h2>
              </div>
              <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6">
                <h3>
                  {`Total de Pedidos ${totais.total}`}
                </h3>
              </div>
              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardAgency
                  data={[
                    { label: 'Triagem', total: totais.triagem, url: `/admin/agencia/pedidos/triagem` },
                    { label: 'Devolvidos', total: totais.devolvidos, url: `/admin/agencia/pedidos/devolvido` },
                    /* { label: 'Aprovação Comercial', total: totais.aprovacaoComercial, url: `/admin/agencia/pedidos/aprovacaoComercial` }, */
                    { label: 'Redação', total: totais.redatora, url: `/admin/agencia/pedidos/redacao` },
                    {
                      label: 'Criação', total: totais.criacao, featured: true, url: `/admin/agencia/pedidos/criacao`
                    },
                    {
                      label: 'Reprovados',
                      total: totais.reprovados,
                      extra: true,
                      url: `/admin/agencia/pedidos/criacao?filtrarpor=reprovados`
                    },
                    {
                      label: 'Atrasados',
                      total: totais.atrasados,
                      extra: true,
                      url: `/admin/agencia/pedidos/criacao?filtrarpor=atrasados`
                    },
                     {
                      label: 'Revisão', total: totais.revisaoInterna, featured: true, url: `/admin/agencia/pedidos/revisaoInterna`
                    },

                  
                    { label: 'Revisão Interna', total: totais.revisaoInterna, extra: true, url: `/admin/agencia/pedidos/revisaoInterna` },
                    { label: 'Supervisão', total: totais.supervisao, url: `/admin/agencia/pedidos/supervisao` },
                    { label: 'Aguardando Aprovação', total: totais.aguardandoAprovacao, featured: true, url: `/admin/agencia/pedidos/aprovacaoDeArte` },
                    { label: 'Redação', total: totais.aguardandoAprovacaoDeRedacao, extra: true, url: `/admin/agencia/pedidos/aprovacaoDeRedacao` },
                    { label: 'Arte', total: totais.aguardandoAprovacaoArte, extra: true, url: `/admin/agencia/pedidos/aprovacaoDeArte` }
                  ]}
                />
              </div>

              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardAgency
                  data={[
                    { label: 'Fechamento de Arquivos', total: totais.fechamentoArquivo, url: `/admin/agencia/pedidos/fechamentoDeArquivo` },
                    { label: 'Orçamento', total: totais.orcamento, url: `/admin/agencia/pedidos/orcamento` },
                    { label: 'Aguardando Produção', total: totais.aguardandoProducao, url: `/admin/agencia/pedidos/aguardandoProducao` },
                    { label: 'Fornecedor', total: totais.fornecedor, url: `/admin/agencia/pedidos/fornecedor` },
                    { label: 'Amostra de Cartão', total: totais.amostraCartao, url: `/admin/agencia/pedidos/amostraCartao` },
                    { label: 'Disponível para Retirada', total: totais.disponivelRetirada, url: `/admin/agencia/pedidos/disponivelParaRetirada` },
                    // { label: 'Em Transporte', total: totais.emTransporte, url: `/admin/agencia/pedidos/emTransporte` },
                    { label: 'Cancelados', total: totais.cancelados, url: `/admin/agencia/pedidos/finalizado` },
                    { label: 'Finalizados', total: totais.finalizados, url: `/admin/agencia/pedidos/finalizado` }
                  ]}
                />
              </div>
            </div>
            <div className="bx--row dashborad-agency">
              <div className="bx--col-md-12 bx--col-xs-12 bx--col-sm-12 chart-designers">
                <CardChartAgency
                  title="Designers"
                  dates={currentDatesCreate}
                  openMd={() => this.openFiltro("criacao")}
                  dataChart={chartCriacao}
                  titleBtnList="Listar Designers"
                  openList={() => this.openMDListDesigners()}
                  data={[
                    { label: 'Total de Pedidos em Criação', total: criacaoDesigners.totalPedidos, url: `/admin/agencia/pedidos/criacao?${this.getDateFilter()}` },
                    { label: 'Total de Itens em Criação', total: criacaoDesigners.totalItens, url: `/admin/agencia/pedidos/criacao?${this.getDateFilter()}` },
                    { label: 'Pedidos de Prioridade Alta', total: criacaoDesigners.prioridadeAlta, url: `/admin/agencia/pedidos/criacao?prioridade=1&${this.getDateFilter()}` },
                    { label: 'Pedidos Reprovados', total: criacaoDesigners.reprovados, url: `/admin/agencia/pedidos/criacao?filtrarpor=reprovados?${this.getDateFilter()}` },
                    { label: 'Pedidos Aguardando Aprovação', total: criacaoDesigners.aguardandoAprovacao, url: `/admin/agencia/pedidos/aguardandoProducao?${this.getDateFilter()}` },
                    { label: 'Pedidos em Fechamento de Arquivo', total: criacaoDesigners.fechamentoArquivo, url: `/admin/agencia/pedidos/fechamentoDeArquivo?${this.getDateFilter()}` },
                  ]}
                />
                <ListCardItens
                  className="zebrados"
                  openModal={() => { this.openMDListDesigners() }}
                  hiddenModal={() => { this.openMDListDesigners() }}
                  openMd={openDesigners}
                  data={listDesigners}
                  dates={currentDatesCreate}
                />
              </div>

              <div className="bx--col-md-12 bx--col-xs-12 bx--col-sm-12 chart-providers">
                <Card className="table-card">
                  <div className="bx--row dashborad-agency" style={{ paddingTop: 50 }}>
                    <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6">
                      <CardChartAgency
                        chartOptions={{ scales: { yAxes: [{ ticks: { max: 5, beginAtZero: true } }] } }}
                        title="Avaliação da Criação"
                        height={120}
                        subtitle="Avaliação dos pedidos finalizados no trimestre"
                        text={`Projeção de média do trimestre: ${mediaTrimestre ? mediaTrimestre.toFixed(2) : "N/A"}`}
                        hideFilter
                        date={trimestre}
                        dataChart={chartAvaliacoesCriacao}
                        data={[
                          { label: 'Média 1º trimestre', total: typeof (avaliacoesCriacao.trimeste1) === 'number' ? avaliacoesCriacao.trimeste1.toFixed(2) : avaliacoesCriacao.trimeste1 },
                          { label: 'Média 2º trimestre', total: typeof (avaliacoesCriacao.trimeste2) === 'number' ? avaliacoesCriacao.trimeste2.toFixed(2) : avaliacoesCriacao.trimeste2 },
                          { label: 'Média 3º trimestre', total: typeof (avaliacoesCriacao.trimeste3) === 'number' ? avaliacoesCriacao.trimeste3.toFixed(2) : avaliacoesCriacao.trimeste3 },
                          { label: 'Média 4º trimestre', total: typeof (avaliacoesCriacao.trimeste4) === 'number' ? avaliacoesCriacao.trimeste4.toFixed(2) : avaliacoesCriacao.trimeste4 }
                        ]}
                      />
                    </div>
                    <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6">
                      <CardChartAgency
                        chartOptions={{ scales: { yAxes: [{ ticks: { max: 5, beginAtZero: true } }] } }}
                        title="Avaliação dos Materiais"
                        height={120}
                        subtitle="Avaliação dos pedidos finalizados no trimestre"
                        text={`Projeção de média do trimestre: ${mediaTrimestre ? mediaTrimestre.toFixed(2) : "N/A"}`}
                        className="avaliacaoCard"
                        openMd={() => this.openFiltro("avaliacoes")}
                        date={trimestre}
                        dataChart={chartAvaliacoesMaterial}
                        data={[
                          { label: 'Média 1º trimestre', total: typeof (avaliacoesMaterial.trimeste1) === 'number' ? avaliacoesMaterial.trimeste1.toFixed(2) : avaliacoesMaterial.trimeste1 },
                          { label: 'Média 2º trimestre', total: typeof (avaliacoesMaterial.trimeste2) === 'number' ? avaliacoesMaterial.trimeste2.toFixed(2) : avaliacoesMaterial.trimeste2 },
                          { label: 'Média 3º trimestre', total: typeof (avaliacoesMaterial.trimeste3) === 'number' ? avaliacoesMaterial.trimeste3.toFixed(2) : avaliacoesMaterial.trimeste3 },
                          { label: 'Média 4º trimestre', total: typeof (avaliacoesMaterial.trimeste4) === 'number' ? avaliacoesMaterial.trimeste4.toFixed(2) : avaliacoesMaterial.trimeste4 }
                        ]}
                      />
                    </div>
                    <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6">
                      <CardChartAgency
                        chartOptions={{ scales: { yAxes: [{ ticks: { max: 5, beginAtZero: true } }] } }}
                        title="Avaliação do Atendimento"
                        height={120}
                        subtitle="Avaliação dos pedidos finalizados no trimestre"
                        text={`Projeção de média do trimestre: ${mediaTrimestre ? mediaTrimestre.toFixed(2) : "N/A"}`}
                        hideFilter
                        date={trimestre}
                        dataChart={chartAvaliacoesAtendimento}
                        data={[
                          { label: 'Média 1º trimestre', total: typeof (avaliacoesAtendimento.trimeste1) === 'number' ? avaliacoesAtendimento.trimeste1.toFixed(2) : avaliacoesAtendimento.trimeste1 },
                          { label: 'Média 2º trimestre', total: typeof (avaliacoesAtendimento.trimeste2) === 'number' ? avaliacoesAtendimento.trimeste2.toFixed(2) : avaliacoesAtendimento.trimeste2 },
                          { label: 'Média 3º trimestre', total: typeof (avaliacoesAtendimento.trimeste3) === 'number' ? avaliacoesAtendimento.trimeste3.toFixed(2) : avaliacoesAtendimento.trimeste3 },
                          { label: 'Média 4º trimestre', total: typeof (avaliacoesAtendimento.trimeste4) === 'number' ? avaliacoesAtendimento.trimeste4.toFixed(2) : avaliacoesAtendimento.trimeste4 }
                        ]}
                      />
                    </div>
                    <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6">
                      <CardChartAgency
                        height={120}
                        chartOptions={{ scales: { yAxes: [{ ticks: { max: 100, beginAtZero: true } }] } }}
                        title=" "
                        subtitle=" "
                        text={`Qnt pedidos avaliados no trimestre: ${qtdAvaliadosTrimestre || "N/A"}`}
                        hideFilter
                        dates={currentDatesProviders}
                        dataChart={chartAvaliacoesRealizadas}
                        data={[
                          { label: 'Total de Pedidos finalizados no trimeste', total: avaliacoes.finalizados },
                          { label: 'Total de Pedidos finalizados e avaliados no trimeste', total: avaliacoes.finalizadosAvaliados },
                          { label: <span>&nbsp;</span>, total: '' },
                          { label: <span>&nbsp;</span>, total: '' },
                        ]}
                      />
                    </div>
                  </div>
                </Card>
              </div>
              <div className="bx--col-md-12 bx--col-xs-12 bx--col-sm-12 chart-providers">
                <CardChartAgency
                  title="Fornecedores"
                  dates={currentDatesProviders}
                  dataChart={chartFornecedores}
                  openMd={() => this.openFiltro("fornecedores")}
                  openList={() => this.openMDListProviders()}
                  openList2={() => this.openMDListProviders2()}
                  titleBtnList2="Listar Pedidos Fornecedores"
                  titleBtnList="Listar Fornecedores"
                  data={[
                    { label: 'Total de Pedidos', total: fornecedores.totalPedidos },
                    { label: 'Produção', total: fornecedores.producao, url: `/admin/agencia/pedidos/fornecedor?${this.getDateFilter()}` },
                    { label: 'Disponível para Retirada', total: fornecedores.disponivelRetirada, url: `/admin/agencia/pedidos/disponivelParaRetirada?${this.getDateFilter()}` },
                    // { label: 'Em Transporte', total: fornecedores.emTransporte, url: `/admin/agencia/pedidos/emTransporte?${this.getDateFilter()}` }
                  ]}
                />
                <ListCardItens
                  openModal={() => { this.openMDListProviders() }}
                  hiddenModal={() => { this.openMDListProviders() }}
                  openMd={openProviders}
                  data={listProviders}
                  dates={currentDatesProviders}
                />
              </div>
            </div>
            <ConsultantsVersosStatus />
          </div>
          {openMdFiltro && (
            <Modal
              className="modal-dashboard-agencia"
              modalHeading="Filtrar"
              primaryButtonText="Aplicar"
              secondaryButtonText="Cancelar"
              onRequestSubmit={() => this.applicationValue()}
              onRequestClose={() => this.openFiltro(filtroOpen)}
              open={openMdFiltro}
              primaryButtonDisabled={selectedOption === 3 ? (!dateInit || !dateFinish) : false}
            >
              <div>
                {filterOpen === 'avaliacoes' && (
                  <div className="bx--row">
                    <div className="bx--col-md-8 bx--col-xs-12 bx--col-sm-6">
                      <div className="bx--form-item">
                        <div className="bx--select">
                          <label
                            className="bx--label"
                          >
                            Trimestre
                          </label>
                          <select
                            id="select-id"
                            className="bx--select-input"
                            onChange={e => this.onChangeTrimestre(e)}
                          >
                            <option
                              className="bx--select-option"
                              value=""
                            >
                              Selecione uma Opção
                            </option>
                            {trimestres && trimestres.map(item => (
                              <option
                                className="bx--select-option"
                                value={item}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {filterOpen !== 'avaliacoes' && (
                  <div className="bx--row">
                    <div className="bx--col-md-8 bx--col-xs-12 bx--col-sm-6">
                      <div className="bx--form-item">
                        <div className="bx--select">
                          <label className="bx--label">
                            Período
                          </label>
                          <select
                            id="select-id"
                            className="bx--select-input"
                            onChange={e => this.onChangeFilter(e)}
                          >
                            <option
                              className="bx--select-option"
                              value="0"
                            >
                              Selecione uma Opção
                            </option>
                            <option
                              className="bx--select-option"
                              value="1"
                            >
                              Hoje
                            </option>
                            <option
                              className="bx--select-option"
                              value="7"
                            >
                              Esta Semana
                            </option>
                            <option
                              className="bx--select-option"
                              value="15"
                            >
                              Últimos 15 dias
                            </option>
                            <option
                              className="bx--select-option"
                              value="2"
                            >
                              Este Mês
                            </option>
                            <option
                              className="bx--select-option"
                              value="3"
                            >
                              Personalizado (sem os atrasados)
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {showDate && (
                  <div className="bx--row dates">
                    <div className="bx--col-md-4 bx--col-xs-6 bx--col-sm-3 calendar-dash-agency">
                      <FormItem className="v-sm-margin">
                        <label className="bx--label">De</label>
                        <DatePicker
                          id="dataInicioFormatada"
                          placeholder="Data Inicial"
                          date={dateInit ? moment(dateInit) : ""}
                          locale="pt"
                          onDateChange={this.onDateChangeInit}
                          isOutsideRange={() => false}
                          readOnly
                        />
                      </FormItem>
                    </div>
                    <div className="bx--col-md-4 bx--col-xs-3 bx--col-sm-3 calendar-dash-agency">
                      <FormItem className="v-sm-margin">
                        <label className="bx--label">Até</label>
                        <DatePicker
                          id="dataFimFormatada"
                          placeholder="Data Final"
                          date={dateFinish ? moment(dateFinish) : ""}
                          locale="pt"
                          onDateChange={this.onDateChangeFinish}
                          readOnly
                          isOutsideRange={() => false}
                        />
                      </FormItem>
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          )}

          {openExportUnificado && (
            <Modal
              className="modal-dashboard-agencia"
              modalHeading="Exportar Excel Unificado"
              primaryButtonText="Exportar"
              secondaryButtonText="Cancelar"
              onRequestSubmit={() => this.exportExcelUnificado()}
              onRequestClose={() => this.openExcelUnificadoModal()}
              open={openExportUnificado}
            >
              <div>
                <p>Você pode exportar os dados de todo período ou filtrar pela `Data de solicitação` preenchendo os campos abaixo.</p>
                <div className="bx--row">
                  <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                    <FormItem className="v-sm-margin">
                      <label className="bx--label">De</label>
                      <DatePicker
                        id="DataInicial"
                        placeholder="Data Inicial"
                        date={DataInicial ? moment(DataInicial) : ""}
                        locale="pt"
                        onDateChange={(date) => this.onDateChange(date, 'DataInicial')}
                        readOnly
                        isOutsideRange={() => false}
                        showClearDate
                      />
                    </FormItem>
                  </div>
                  <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                    <FormItem className="v-sm-margin">
                      <label className="bx--label">Até</label>
                      <DatePicker
                        id="DataFinal"
                        placeholder="Data Final"
                        date={DataFinal ? moment(DataFinal) : ""}
                        locale="pt"
                        onDateChange={(date) => this.onDateChange(date, 'DataFinal')}
                        readOnly
                        isOutsideRange={() => false}
                        showClearDate
                      />
                    </FormItem>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {openExport && (
            <Modal
              className="modal-dashboard-agencia"
              modalHeading="Exportar planilha"
              primaryButtonText="Exportar"
              secondaryButtonText="Cancelar"
              onRequestSubmit={() => this.exportExcel()}
              onRequestClose={() => this.openExelModal()}
              open={openExport}
            >
              <div>
                <p>Você pode exportar os dados de todo período ou filtrar pela `Data de solicitação` preenchendo os campos abaixo.</p>
                <div className="bx--row">
                  <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                    <FormItem className="v-sm-margin">
                      <label className="bx--label">De</label>
                      <DatePicker
                        id="DataInicial"
                        placeholder="Data Inicial"
                        date={DataInicial ? moment(DataInicial) : ""}
                        locale="pt"
                        onDateChange={(date) => this.onDateChange(date, 'DataInicial')}
                        readOnly
                        isOutsideRange={() => false}
                        showClearDate
                      />
                    </FormItem>
                  </div>
                  <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                    <FormItem className="v-sm-margin">
                      <label className="bx--label">Até</label>
                      <DatePicker
                        id="DataFinal"
                        placeholder="Data Final"
                        date={DataFinal ? moment(DataFinal) : ""}
                        locale="pt"
                        onDateChange={(date) => this.onDateChange(date, 'DataFinal')}
                        readOnly
                        isOutsideRange={() => false}
                        showClearDate
                      />
                    </FormItem>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {openExportAgencia && (
            <Modal
              className="modal-dashboard-agencia"
              modalHeading="Exportar planilha Agência"
              primaryButtonText="Exportar"
              secondaryButtonText="Cancelar"
              onRequestSubmit={() => this.exportExcelStatus()}
              onRequestClose={() => this.openExelAgenciaModal()}
              open={openExportAgencia}
            >
              <div>
                <p>Você pode exportar os dados filtrando pela `Data de solicitação`, preenchendo os campos abaixo.</p>
                <div className="bx--row">
                  <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                    <FormItem className="v-sm-margin">
                      <label className="bx--label">De</label>
                      <DatePicker
                        id="DataInicial"
                        placeholder="Data Inicial"
                        date={DataInicial ? moment(DataInicial) : ""}
                        locale="pt"
                        onDateChange={(date) => this.onDateChange(date, 'DataInicial')}
                        readOnly
                        isOutsideRange={() => false}
                        showClearDate
                      />
                    </FormItem>
                  </div>
                  <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                    <FormItem className="v-sm-margin">
                      <label className="bx--label">Até</label>
                      <DatePicker
                        id="DataFinal"
                        placeholder="Data Final"
                        date={DataFinal ? moment(DataFinal) : ""}
                        locale="pt"
                        onDateChange={(date) => this.onDateChange(date, 'DataFinal')}
                        readOnly
                        isOutsideRange={() => false}
                        showClearDate
                      />
                    </FormItem>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          <ModalDm
            openModal={this.openMDListProviders2}
            heading="Selecione o fornecedor"
            hiddenModal={this.openMDListProviders2}
            openMd={openProviders2}
          >
            <div>
              <div className="bx--modal-content" style={{ maxHeight: 500, minHeight: 360 }}>
                <div className="bx--row">
                  <div className="bx--col-md-12">
                    <Select
                      placeholder="Selecione o fornecedor"
                      name="product"
                      options={fornecedoresSelecionados.map(p => ({ id: p.id, label: p.nome }))}
                      value={fornecedorSelecionado}
                      onChange={e => this.onChangeFornecedor(e)}
                      isClearable={false}
                      isSearchable
                    />
                  </div>
                </div>
                <div className="bx--row">
                  <div className="bx--col-md-12">
                    <DataTable
                      rows={rowsData}
                      headers={headersData}
                      render={({ rows, headers, getHeaderProps }) => (
                        <TableContainer>
                          <Table className="responsive-carbon-table">
                            <TableHead>
                              <TableRow>
                                {width < 1024 && (<TableHeader />)}
                                {width >= 1024 && headers.map(header => (
                                  <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {width >= 1024 && rows.map(row => (
                                <TableRow key={row.id}>
                                  {row.cells.map(cell => (
                                    <TableCell onClick={() => this.handleDetail(rowsData, row)} key={cell.id}>{cell.value}</TableCell>
                                  ))}
                                </TableRow>
                              ))}
                              {width < 1024 && rows.map(row => (
                                <TableRow key={`${row.id}`}>
                                  <TableCell
                                    key={`row-${row.id}`}
                                    className="pointer"
                                    onClick={() => this.goEditAgency(row)}
                                  >
                                    <Card className="table-card">
                                      {row.cells.map(cell => (
                                        <p>
                                          {headers.find(obj => obj.key === cell.info.header).header}
                                          :
                                          <strong>{` ${cell.value || ""}`}</strong>
                                        </p>
                                      ))}
                                    </Card>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </ModalDm>
        </section>
      </div>
    );
  }
}

export default connect()(Dashboard);



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/agency.js